import { render, staticRenderFns } from "./SuggestionSupport.vue?vue&type=template&id=a8729832&"
import script from "./SuggestionSupport.vue?vue&type=script&lang=js&"
export * from "./SuggestionSupport.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionSupport.vue?vue&type=style&index=0&id=a8729832&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports